<template>
    <div class="w-100 d-flex align-items-center">
        <template v-if="!isEditCity">
            <div class="qf-w-20 pl-3 text-left qf-fs-90">
                {{$ml.get('city')}}
            </div>
            <div class="qf-w-60 pl-3 text-left">
                <strong>{{ userCity }}</strong>
            </div>
            <div class="qf-w-20 pr-3 text-right">
                <a href="#!"
                   class="btn btn-outline-dark btn-sm"
                   @click.prevent="openEditCity">
                    <font-awesome-icon icon="pen"/>
                </a>
            </div>
        </template>
        <form v-else
              class="w-100"
              @submit.prevent="editCity">
            <div class="form-row align-items-center px-3">
                <div class="col flex-grow-0">
                    {{$ml.get('city')}}
                </div>
                <div class="col flex-grow-1">
                    <input type="text"
                           class="form-control form-control-sm"
                           name="city"
                           v-validate="'required'"
                           :class="{'is-invalid': errors.has('city')}"
                           v-model="formData.billing_info.city"
                           :placeholder="$ml.get('city')"/>
                </div>
                <div class="col flex-grow-0 text-right">
                    <button class="btn btn-warning btn-sm btn-fixed-width"
                            type="submit"
                            :disabled="loading">
                        <font-awesome-icon icon="spinner" class="fa-spin" v-if="loading"/>
                        <font-awesome-icon icon="save" v-else/>
                    </button>
                </div>
                <div class="col flex-grow-0 text-right">
                    <button class="btn btn-outline-dark btn-sm btn-fixed-width"
                            @click.prevent="closeEditCity"
                            :disabled="loading">
                        <font-awesome-icon icon="times"/>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "EditCityForm",
        data() {
            return {
                formData: {
                    billing_info: {
                        city: ''
                    }
                },
                isEditCity: false,
                loading: false
            }
        },
        computed: {
            userCity() {
                if (this.$store.state.loggedUser.billing_info) {
                    return this.$store.state.loggedUser.billing_info.city;
                }
            }
        },
        methods: {
            openEditCity() {
                if (this.$store.state.loggedUser.billing_info) {
                    this.formData.billing_info.city = this.$store.state.loggedUser.billing_info.city;
                }
                this.isEditCity = true;
            },
            closeEditCity() {
                this.isEditCity = false;
                this.loading = false;
            },
            editCity() {
                this.loading = true;
                this.$emit('saveData', this.formData, 'City', 'editCityRef');
            }
        }
    }
</script>
